import Vue from "vue";
import url from "./apiurls";

export const subscriptionApi = new Vue({
  methods: {
    getPaymentMethods() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getPaymentMethods)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    orderCreation(orderData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.orderCreation, orderData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    paymentValidation(paymentDetails) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.paymentValidation, paymentDetails)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
